import React, { useId } from "react";

const PaymentArtwork = ({ gradientId }) => (
  <>
    <defs>
      <linearGradient id={gradientId}>
        <stop stopColor="#cf8061" stopOpacity="0.35" />
        <stop offset="0.65" stopColor="#b9f227" stopOpacity="0.8" />
        <stop offset="1" stopColor="#b9f227" stopOpacity="0.18" />
      </linearGradient>
    </defs>
    <path
      className="dossier-art-faint"
      d="M0 40H400M0 76H400M0 112H400M0 148H400M0 184H400"
    />
    <g fill="none" stroke={"url(#" + gradientId + ")"} strokeWidth="1.5">
      <path d="M-20 140C60 140 90 40 168 40H220M248 40H430" />
      <path d="M-20 170C70 170 106 76 168 76H220M248 76H430" />
      <path d="M-20 98C50 98 110 112 168 112H220M248 112H430" />
      <path d="M-20 48C50 48 80 148 168 148H220M248 148H430" />
      <path d="M-20 68C64 68 76 184 168 184H220M248 184H430" />
    </g>
    <g className="dossier-art-block">
      {[27, 63, 99, 135, 171].map((y) => (
        <rect key={y} x="220" y={y} width="28" height="26" rx="2" />
      ))}
    </g>
    <path
      className="dossier-art-signal"
      opacity="0.7"
      d="M229 37H238M229 43H238M229 73H238M229 79H238M229 109H238M229 115H238M229 145H238M229 151H238M229 181H238M229 187H238"
    />
    <g className="dossier-art-dot">
      {[
        [302, 40],
        [349, 76],
        [285, 112],
        [326, 148],
        [369, 184],
      ].map(([x, y]) => (
        <circle key={y} cx={x} cy={y} r="2.5" />
      ))}
    </g>
  </>
);

const IndexerArtwork = () => (
  <>
    <path
      className="dossier-art-faint"
      d="M22 28H378M22 192H378M180 24V196M214 24V196M248 24V196M282 24V196M316 24V196M350 24V196"
    />
    <rect x="236" y="29" width="24" height="162" fill="#b9f227" opacity="0.045" />
    <path
      className="dossier-art-signal"
      d="M-10 110H416"
    />
    <g className="dossier-art-block">
      {[24, 71, 118].map((x) => (
        <rect key={x} x={x} y="96" width="28" height="28" rx="2" />
      ))}
    </g>
    <path
      className="dossier-art-structure"
      d="M32 104H44M32 111H40M79 104H91M79 111H87M126 104H138M126 111H134"
    />
    <g className="dossier-art-signal" opacity="0.38" style={{ strokeWidth: 1 }}>
      {[180, 214, 248, 282, 316, 350].map((x) => (
        <path key={x} d={`M${x} 110V95M${x} 110V125`} />
      ))}
    </g>
    <g className="dossier-art-block">
      {[
        [180, 2, 1],
        [214, 3, 2],
        [248, 4, 2],
        [282, 2, 3],
        [316, 3, 1],
        [350, 1, 2],
      ].map(([x, above, below]) =>
        [-1, 1].map((direction) =>
          Array.from({ length: direction < 0 ? above : below }, (_, row) => (
            <rect
              key={`${x}-${direction}-${row}`}
              x={x - 12}
              y={direction < 0 ? 84 - row * 20 : 120 + row * 20}
              width="24"
              height="16"
              rx="1"
            />
          )),
        ),
      )}
    </g>
    <g className="dossier-art-dot">
      <rect x="236" y="64" width="24" height="16" rx="1" opacity="0.28" />
      <circle cx="165" cy="110" r="2.5" />
      <circle cx="373" cy="110" r="2.5" />
    </g>
  </>
);

const PipelineArtwork = ({ gradientId }) => (
  <>
    <defs>
      <linearGradient
        id={gradientId}
        x1="0"
        y1="0"
        x2="154"
        y2="0"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#cf8061" stopOpacity="0.2" />
        <stop offset="0.48" stopColor="#cf8061" stopOpacity="0.48" />
        <stop offset="1" stopColor="#b9f227" stopOpacity="0.74" />
      </linearGradient>
    </defs>
    <path
      className="dossier-art-faint"
      d="M12 35H156M12 66H156M12 97H156M12 128H156M12 159H156M168 25V195M276 25V195"
    />
    <g
      fill="none"
      stroke={"url(#" + gradientId + ")"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M0 35H24C65 35 97 135 138 135H154" />
      <path d="M0 66H24C74 66 84 59 138 59H154" />
      <path d="M0 97H24C70 97 87 135 138 135H154" />
      <path d="M0 128H24C70 128 87 59 138 59H154" />
      <path d="M0 159H24C70 159 87 135 138 135H154" />
    </g>
    <path
      className="dossier-art-signal"
      d="M154 59H184M264 59H280Q296 59 296 75V81Q296 97 312 97H418"
    />
    <path
      className="dossier-art-signal"
      d="M154 135H184M264 135H280Q296 135 296 119V113Q296 97 312 97"
    />
    <g className="dossier-art-block">
      <rect x="184" y="38" width="80" height="42" rx="3" />
      <rect x="184" y="114" width="80" height="42" rx="3" />
    </g>
    <path
      className="dossier-art-structure"
      d="M198 49V69M211 49V69M224 49V69M237 49V69M250 49V69M196 124H252M196 135H252M196 146H252"
    />
    <g className="dossier-art-dot">
      <rect x="208" y="51" width="6" height="16" rx="1" opacity="0.45" />
      <rect x="234" y="51" width="6" height="16" rx="1" opacity="0.2" />
      <rect x="197" y="121" width="13" height="6" opacity="0.35" />
      <rect x="218" y="132" width="13" height="6" opacity="0.45" />
      <rect x="239" y="143" width="12" height="6" opacity="0.35" />
      <circle cx="280" cy="59" r="2.5" />
      <circle cx="168" cy="135" r="2.5" />
      <circle cx="352" cy="97" r="2.5" />
    </g>
    <path
      className="dossier-art-signal"
      opacity="0.2"
      d="M329 139H418M341 153H418"
    />
  </>
);

const ActivityArtwork = () => (
  <>
    <circle className="dossier-art-halo" cx="234" cy="111" r="76" />
    <circle className="dossier-art-faint" cx="234" cy="111" r="105" />
    <path
      className="dossier-art-cluster"
      d="M191 76Q207 44 250 59Q296 77 290 130Q274 177 217 165Q176 144 191 76Z"
    />
    <path
      className="dossier-art-structure"
      d="M31 42L97 68L86 152L39 184M97 68L143 111L132 190M330 36L364 113L339 190M234 111L143 111M234 111L364 113"
    />
    <path
      className="dossier-art-bright"
      opacity="0.6"
      d="M234 111L212 74L263 88L273 138L221 147L234 111L263 88M212 74L221 147M234 111L273 138"
    />
    <g className="dossier-art-dust">
      {[
        [31, 42],
        [97, 68],
        [86, 152],
        [39, 184],
        [143, 111],
        [132, 190],
        [330, 36],
        [364, 113],
        [339, 190],
      ].map(([x, y]) => (
        <circle key={x} cx={x} cy={y} r="3" />
      ))}
    </g>
    <g className="dossier-art-dot">
      {[
        [212, 74],
        [263, 88],
        [273, 138],
        [221, 147],
      ].map(([x, y]) => (
        <circle key={x} cx={x} cy={y} r="3" />
      ))}
      <circle cx="234" cy="111" r="6" />
    </g>
    <circle
      className="dossier-art-bright"
      cx="234"
      cy="111"
      r="11"
      opacity="0.55"
    />
    <path
      className="dossier-art-bright"
      d="M300 71A76 76 0 0 1 310 111"
      opacity="0.8"
    />
  </>
);

const ARTWORKS = {
  "001": {
    Component: PaymentArtwork,
    description:
      "Five transaction streams enter separate workers and continue in independent processing lanes",
  },
  "002": {
    Component: IndexerArtwork,
    description:
      "A straight block stream feeds index columns of different heights above and below a shared baseline",
  },
  "003": {
    Component: PipelineArtwork,
    description:
      "Mixed request streams feed two balanced cache and indexed database routes, then rejoin as a stable stream",
  },
  "004": {
    Component: ActivityArtwork,
    description:
      "User-activity nodes across chains feed a highlighted trigger-signal cluster",
  },
};

export default function CaseArtwork({ caseId }) {
  const id = useId().replace(/:/g, "");
  const artwork = ARTWORKS[caseId];
  if (!artwork) return null;
  const { Component, description } = artwork;
  const edgeMaskId = "case-edge-mask-" + id;
  return (
    <div className="dossier-case-visual" role="img" aria-label={description}>
      <svg
        viewBox="0 0 400 220"
        preserveAspectRatio="xMidYMid meet"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id={edgeMaskId + "-gradient"} x1="0" x2="1">
            <stop offset="0" stopColor="white" stopOpacity="0" />
            <stop offset="0.07" stopColor="white" />
            <stop offset="0.93" stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
          <mask
            id={edgeMaskId}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="400"
            height="220"
          >
            <rect
              width="400"
              height="220"
              fill={"url(#" + edgeMaskId + "-gradient)"}
            />
          </mask>
        </defs>
        <g mask={"url(#" + edgeMaskId + ")"}>
          <Component gradientId={"payment-flow-" + id} />
        </g>
      </svg>
    </div>
  );
}
